import { buildCareRouteUrl } from '@/services/careUrls';

export interface FlepzRedirectPayload {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    zipCode: string;
    email: string;
}

export function buildFlepzRedirectUrl(payload: FlepzRedirectPayload): string | undefined {
    if (typeof window === 'undefined') {
        return undefined;
    }

    const encodedPayload = window.btoa(
        JSON.stringify({
            firstName: payload.firstName,
            lastName: payload.lastName,
            phoneNumber: payload.phoneNumber,
            zipCode: payload.zipCode,
            email: payload.email,
        }),
    );

    return buildCareRouteUrl('flepzSetupCredentials', {
        queryParams: {
            flepz: encodedPayload,
        },
    });
}
